import { Box, Typography, useTheme, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import { useTranslation } from 'react-i18next'

const FilterContainer = styled(Box)({
    marginBottom: '2.8rem',
})

const CollapsibleFilterPanel = ({ openFilters, setOpenFilters }) => {
    const { t } = useTranslation()
    const theme = useTheme()

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            setOpenFilters()
        }
    }

    const toggleButton = (
        <Box
            component="span"
            display="flex"
            tabIndex={0}
            role="button"
            aria-expanded={openFilters}
            aria-label={openFilters ? 'Hide filters' : 'Show filters'}
            data-ai-explain={openFilters ? 'Hide filters' : 'Show filters'}
            data-ai-explain-section="filters"
            sx={{
                textTransform: 'uppercase',
                // zIndex: 9999,
                marginTop: '0.2rem',
                color: '#0057A0',
                fontSize: '1.2rem',
                fontWeight: '600',
                '&:hover': {
                    cursor: 'pointer',
                },
                '&:focus': {
                    outline: `0.2rem solid ${theme?.palette?.primary?.main}`,
                    outlineOffset: '0.2rem',
                    borderRadius: '0.4rem',
                },
                '&:focus-visible': {
                    outline: `0.2rem solid ${theme?.palette?.primary?.main}`,
                    outlineOffset: '0.2rem',
                    borderRadius: '0.4rem',
                },
            }}
            onClick={setOpenFilters}
            onKeyDown={handleKeyDown}
        >
            {openFilters ? t('Hide') : t('Show')}
            <Box
                sx={{
                    width: '1.6rem',
                    height: '1.6rem',
                    marginLeft: '0.8rem',
                    borderRadius: '50%',
                    border: `0.1rem solid ${theme?.palette?.primary?.main}`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: theme?.palette?.primary?.main,
                    lineHeight: '0',
                    fontSize: '1.5rem',
                }}
            >
                {openFilters ? '-' : '+'}
            </Box>
        </Box>
    )

    return (
        <FilterContainer
            data-ai-explain="Filters section: show or hide filter options"
            data-ai-explain-section="filters"
        >
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    height: '4rem',
                    borderBottom: openFilters ? '.1rem solid #d8d8d8' : 'none',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        gap: '.8rem',
                        alignItems: 'center',
                        justifyContent: openFilters
                            ? 'space-between'
                            : 'flex-start',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '.8rem',
                            alignItems: 'center',
                        }}
                    >
                        <Icon name="FilterBar" color="#959598" />
                        <Typography
                            component="span"
                            data-ai-explain="Filters section label"
                            data-ai-explain-section="filters"
                            sx={{
                                fontWeight: '700',
                                fontSize: '1.8rem',
                                color: '#3b454d',
                            }}
                        >
                            {t('Filters')}
                        </Typography>
                        {/* Show button next to Filters label when filters are hidden */}
                        {!openFilters && toggleButton}
                    </Box>
                    {/* Hide button on the right when filters are open */}
                    {openFilters && toggleButton}
                </Box>
            </Box>
        </FilterContainer>
    )
}

export default CollapsibleFilterPanel
